import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

export interface CreateWorkspaceSliceState {
  CreateWorkspaceFirstStep: {
    workspaceName: string
  }
  CreateWorkspaceSecondStep: {
    createTeamArray: string[]
  }
  CreateWorkspaceThirdStep: {
    members: {
      email: string
      teamWhichBelong: string[]
      role: string
    }[]
  }
}

export const createWorkspaceInitialState: CreateWorkspaceSliceState = {
  CreateWorkspaceFirstStep: {
    workspaceName: '',
  },
  CreateWorkspaceSecondStep: {
    createTeamArray: [],
  },
  CreateWorkspaceThirdStep: {
    members: [],
  },
}

const createWorkspaceSlice = createSlice({
  name: 'createWorkspace',
  initialState: createWorkspaceInitialState,
  reducers: {
    setCreateWorkspaceFirstStep: (state, action) => {
      const workspaceName = action.payload.workspaceName
      state.CreateWorkspaceFirstStep = { workspaceName }
    },
    setCreateWorkspaceSecondStep: (state, action) => {
      const workspaceSecond = action.payload
      state.CreateWorkspaceSecondStep = { ...workspaceSecond }
    },
    setCreateWorkspaceThirdStep: (
      state,
      action: PayloadAction<{
        email: string
        teamWhichBelong: string[]
        role: string
      }>,
    ) => {
      const newMember = {
        email: action.payload.email,
        teamWhichBelong: action.payload.teamWhichBelong,
        role: action.payload.role,
      }
      state.CreateWorkspaceThirdStep.members.push(newMember)
    },

    clearSignUpState: (state) => {
      state.CreateWorkspaceFirstStep =
        createWorkspaceInitialState.CreateWorkspaceFirstStep
      state.CreateWorkspaceSecondStep =
        createWorkspaceInitialState.CreateWorkspaceSecondStep
      state.CreateWorkspaceThirdStep =
        createWorkspaceInitialState.CreateWorkspaceThirdStep
    },
  },
})
export const {
  setCreateWorkspaceFirstStep,
  setCreateWorkspaceSecondStep,
  setCreateWorkspaceThirdStep,
  clearSignUpState,
} = createWorkspaceSlice.actions

export default createWorkspaceSlice.reducer
